<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>
      Rechnung suchen
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text class="pa-2">
      <v-autocomplete
        outlined
        clearable
        dense
        hide-details
        label="Rechnungsnummer eingeben"
        @change="selectRechnung ? (showRechnung = true) : (showRechnung = false)"
        :items="rechnungen"
        v-model="selectRechnung"
      >
        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title>{{ data.item.item.rechnungsnummer }} | {{ data.item.item.kasse }}</v-list-item-title>
            <v-list-item-subtitle>{{ $filters.user(data.item.item.bbrID, bbrbbr) }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            {{ data.item.item.summe | money }}
          </v-list-item-action>
        </template>
      </v-autocomplete>
    </v-card-text>
    <dialogRechnung
      :visible.sync="showRechnung"
      :rechnungid="selectRechnung"
      @close="showRechnung = false"
    ></dialogRechnung>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        selectRechnung: {},
        showRechnung: false,
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      rechnungen() {
        if (this.$store.state.rechnungen.loaded === false) {
          this.$store.dispatch("rechnungen/loadRechnungen");
        }
        let rechnungen = [];
        this.$store.state.rechnungen.rechnungen.forEach((item) => {
          rechnungen.push({
            value: item.id,
            text: item.rechnungsnummer + " " + item.bbr + " " + item.summe.toFixed(2) + "€",
            item: item,
          });
        });
        rechnungen.sort((a, b) => {
          // Die Rechnungsnummer als Zahl interpretieren und vergleichen
          return b.item.rechnungsnummer.localeCompare(a.item.rechnungsnummer);
        });
        return rechnungen;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// rechnungSuche.vue?b7108572